module.exports = __webpack_public_path__ + "img/404.26b2ae83.png";